import { Typography, Row, Col, Space } from 'antd';
import moment from 'moment';
import Data from '../../../CustomText/data';
import { convertCentsIntoDollar, formatDate } from '../../../../helpers/genericHelper';

export default function PaymentSchedule({ paymentSchedule, loading }) {
    const { Text, Title } = Typography;
    
    if (loading) {
        return <Text>Loading...</Text>;
    }

    if (!paymentSchedule || paymentSchedule.length === 0) {
        return <Text>No Payment Schedule Available</Text>;
    }

    const today = moment().startOf('day');
    return (
        <>
            <Space direction="vertical" style={{ width: '100%' }}>
            <Row >
                <Col span={2}></Col>
                <Col span={4} style={{ textAlign: 'center' }}>
                    <Title level={5}>
                        Scheduled Date
                    </Title>
                </Col>
                <Col span={4} style={{ textAlign: 'center' }}>
                    <Title level={5}>
                        Payment Amount
                    </Title>
                </Col>
                <Col span={4} style={{ textAlign: 'center' }}>
                    <Title level={5}>
                        Fees
                    </Title>
                </Col>
                <Col span={4} style={{ textAlign: 'center' }}>
                    <Title level={5}>
                        Principal Amount
                    </Title>
                </Col>
                
                <Col span={4} style={{ textAlign: 'center' }}>
                    <Title level={5}>
                        Status
                    </Title>
                </Col>
            </Row>
            {paymentSchedule.sort((a, b) => a.paymentNumber - b.paymentNumber).map((payment, index) => (
            <Row key={index}>
                <Col span={2}>{payment.paymentNumber}</Col>
                <Col span={4} style={{ textAlign: 'center' }}>
                    <Text>
                        {formatDate(payment?.scheduledDate)}
                    </Text>
                </Col>
                <Col span={4} style={{ textAlign: 'center' }}>
                    <Text>
                        {convertCentsIntoDollar(payment.paymentAmount)}
                    </Text>
                </Col>
                <Col span={4} style={{ textAlign: 'center' }}>
                    <Text>
                        {payment.feesAmount ? convertCentsIntoDollar(payment.feesAmount) : 'N/A'}
                    </Text>
                </Col>
                <Col span={4} style={{ textAlign: 'center' }}>
                    <Text>
                        {payment.principalAmount ? convertCentsIntoDollar(payment.principalAmount) : 'N/A'}
                    </Text>
                </Col>
                <Col span={4} style={{ textAlign: 'center' }}>
                    <Text mark={today.isAfter(moment(payment.scheduledDate))}>
                        {today.isAfter(moment(payment.scheduledDate)) ? 'Due' : 'Scheduled'}
                    </Text>
                </Col>
            </Row>
            ))}
            </Space>
        </>
    );
}